import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom ml-4" }
const _hoisted_2 = { class: "submitissue-tab__content" }
const _hoisted_3 = { class: "p-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_DialogReportEpIssue = _resolveComponent("DialogReportEpIssue")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("entrancePlant.clickSubmitIssueDetails")), 1),
        _createVNode(_component_Button, {
          class: "p-button-rounded mt-3 p-button-outlined",
          onClick: _ctx.toggleReportIssueDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.SubmitIssueDetails")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_DialogReportEpIssue, {
      "is-visible": _ctx.isVisibleDialogIssueProblem,
      onHideDialog: _ctx.toggleReportIssueDialog
    }, null, 8, ["is-visible", "onHideDialog"])
  ], 64))
}